import ActivityDrawer from "../../../../parts/activity-drawer/ActivityDrawer";
import StepCount from "./StepCount";
import _ from "lodash";
import { isAdminOrOwner } from "../../../../utils/organization-permissions-helpers";

const StepCountController = (app) => {
  app.get("/step-count", async ({ res, req, locals, load }) => {
    const { query } = req;

    const isAllowToViewAllOrganizationsAthletes = isAdminOrOwner(
      locals.organizationRoleName
    );

    if (
      locals.activeUser.organizationId &&
      isAllowToViewAllOrganizationsAthletes &&
      !locals.allAthletesFromOrganization
    ) {
      await load("allAthletesFromOrganization");
    }

    const { bodycomp, showBack } = query;

    let comesFromBodyComp = false;

    // Required conditional because this could be undefined when refreshing
    if (Boolean(bodycomp) && req?.original?.headers?.referer) {
      console.log(req.original.headers.referer);

      comesFromBodyComp =
        req.original.headers.referer.includes("body-composition");
    }
    if (showBack) comesFromBodyComp = true;
    const modal = _.get(query, "modal", {});
    locals.modal = {
      "activity-feed": <ActivityDrawer />,
    }[modal.type];
    res.body = <StepCount comesFromBodyComp={comesFromBodyComp} />;
  });
};

export default StepCountController;
